import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ADMIN_CONFIG} from '../../../environments/environment';
import {Response} from '../_base/crud/models/response';
import {User} from '../auth';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class EtayssirService {
    basicUrl: string;

    constructor(private http: HttpClient) {
        this.basicUrl = `${ADMIN_CONFIG.apiEndpoint}api/e-taysir`;
    }

    updateCompliantDocumentUrl(folderReqNumber: string, documentUrl: string) {
        const url = `${this.basicUrl}/documents/${folderReqNumber}/compliant-url?compliantDocumentUrl=${documentUrl}`;
        return this.http.put<Response<User>>(url, {});
    }
}
